import React, { useState } from "react";
import { MESSAGES } from "../../../constants";
import { isExactMatch } from "../../../shared/utility";
import GenericButton from "../../../components/shared/GenericButton";

const OrderLevelRefund = ({
  handleClick,
  loading = false,
  order,
  currencyCode,
}) => {
  const totalRefund =
    parseFloat(order?.total_inc_tax || 0) -
    parseFloat(order?.refunded_amount || 0);
  const [refundAmount, setRefundAmount] = useState("");
  const isExceeding = parseFloat(refundAmount) > totalRefund;

  const isInvalidAmount =
    refundAmount !== "" &&
    (isNaN(refundAmount) ||
      refundAmount <= 0 ||
      parseFloat(refundAmount) > totalRefund);

  const isButtonDisabled =
    refundAmount === "" ||
    isNaN(refundAmount) ||
    refundAmount <= 0 ||
    parseFloat(refundAmount) > totalRefund;

  const handleChange = (e) => {
    const value = parseFloat(e.target.value);
    if (isNaN(value) || value <= 0) {
      setRefundAmount("");
    } else {
      setRefundAmount(value);
    }
  };

  return (
    <>
      <div className="card-container order-summary-container">
        <div className="card mb-4">
          <div className="card-body">
            <p>
              Order level refunds are useful to refund a shopper without
              associating the refund to a specific order item.
            </p>
            <div
              className="alert text-muted shadow-sm mt-3"
              role="alert"
              style={{
                backgroundColor: "#fff3cd", // Bootstrap's $warning-bg color
                border: "none",
                borderRadius: "0.375rem", // default Bootstrap border radius
              }}
            >
              <strong>
                Refunding an exact amount will not change tax liability of the
                order.
              </strong>
              <div className="mt-1">
                This method alone will not refund any tax for any line items and
                will not change tax liability that was previously calculated for
                this order. If you still see a tax component to refund, they are
                usually due to changes in tax exemption of the customer or tax
                provider/rates.
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="refund-amount" className="form-label">
                Amount to be refunded
              </label>
              <div
                className="input-group input-group-sm"
                style={{ maxWidth: "250px" }}
              >
                <span className="input-group-text">{currencyCode}</span>
                <input
                  type="number"
                  className={`form-control ${isInvalidAmount ? "error" : ""}`}
                  id="refund-amount"
                  placeholder="0.00"
                  value={refundAmount}
                  onChange={handleChange}
                />
              </div>
              <p style={{ fontSize: "12px" }}>
                Total funds available for refund {currencyCode}
                {totalRefund}
              </p>
            </div>
          </div>
        </div>
      </div>

      {!isExactMatch(order.status, MESSAGES.REFUNDED) && (
        <div className="d-flex justify-content-end mb-3">
          <GenericButton
            btnText={"Refund"}
            isDisabled={isButtonDisabled || isExceeding}
            handleClick={() => handleClick(refundAmount)}
            loading={loading}
          />
        </div>
      )}
    </>
  );
};

export default OrderLevelRefund;
